// extracted by mini-css-extract-plugin
module.exports = {"panel":"JobDetailPage_panel_29_gj","kill-job-button":"JobDetailPage_kill-job-button_J56n0"};